// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditStore_inner__38c-4","pane":"EditStore_pane__1vIn8"};